var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "menu_version--container",
      attrs: { "aria-hidden": "true" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.handleContainerClick.apply(null, arguments)
        },
      },
    },
    [_vm._v("\n  " + _vm._s(_vm.version) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }